import { render, staticRenderFns } from "./FileLimitUploaderState.vue?vue&type=template&id=19b28b1c&lang=pug"
import script from "./FileLimitUploaderState.vue?vue&type=script&lang=ts"
export * from "./FileLimitUploaderState.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports